import React from "react";
import FacebookSvg from "../../assets/svgs/FacebookSvg";
import InstagramSvg from "../../assets/svgs/InstagramSvg";
import YoutubeSvg from "../../assets/svgs/YoutubeSvg";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { useTranslation } from "react-i18next";

interface NavItemProps {
  to: string;
  title: string;
  className?: string;
}

const NAVITEM = (props: NavItemProps) => {
  const { to, title, className } = props;
  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={`mx-auto cursor-pointer select-none ${className}`}
    >
      {title}
    </a>
  );
};

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Footer */}
      <section
        className="w-full flex flex-col items-center py-[2rem] text-white border-t"
        style={{ borderTopWidth: 0.5, borderColor: "#2a2a2a" }}
      >
        <a href="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[16rem] my-3 cursor-pointer "
          />
        </a>

        <div className="text-[1.5rem] md:text-[1.7rem] font-bold flex flex-col md:flex-row justify-center items-center my-[2.5rem] text-center">
          Follow us on
          <div className="my-2 md:hidden" />
          <div className="flex">
            <FacebookSvg
              to="https://www.facebook.com/casino24com/"
              className="mx-4"
            />
            <InstagramSvg
              to="https://www.instagram.com/casino24com/"
              className="mr-6"
            />
            <YoutubeSvg to="https://www.youtube.com/channel/UCQdqfWYYcboANDQn6wYa8WA" />
          </div>
        </div>

        <nav className="text-[1rem] lg:text-[1.3rem] grid md:grid-cols-3 text-center gap-2 mb-[1.5rem]">
          <NAVITEM to="about-us" title={t("about_us")} />
          <NAVITEM to="play-responsibly" title={t("play_responsibly")} />
          <NAVITEM
            to="terms-and-conditions"
            title={t("terms_and_conditions")}
          />
        </nav>

        <div className="text-[1rem] lg:text-[1.3rem] flex items-center justify-center mb-[2.5rem]">
          <h2 className="mx-2 cursor-pointer select-none">
            {t("casino_provider")}
          </h2>
          <NAVITEM to="imprint" title="Imprint" />
        </div>

        <h2 className="text-[1.5rem] pb-4">
          <b>Be</b>Gamble<b>Aware</b>
        </h2>
      </section>

      {/* Copyright section */}
      <section className="w-full bg-black flex justify-center items-center py-3 text-[1rem] select-none text-white">
        © Copyright 2022{" "}
        <span className="cursor-pointer mx-2 hover:underline">
          <a href="/">Casino24.com</a>
        </span>
      </section>
    </>
  );
};

export default Footer;
